import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** "PENDING_KYB" -> "Pending kyb" — for displaying enum values as a label. */
export function formatStatusLabel(value: string): string {
  const withSpaces = value.replace(/_/g, " ").toLowerCase();
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}
